import NavigationTitle from '$src/components/NavigationTitle';
import { HOW_VSG_WORKS_URL } from '$src/constants/urls';
import { PlanBenefitsIcon } from '@ring-icons';
import Benefits from './Benefits';

import './TrialBenefits.less';

function TrialBenefits() {
  return (
    <div className="trial-benefits page-devices-wrapper" data-testid="trial-benefits">
      <NavigationTitle title="Virtual Security Guard Benefits" icon={PlanBenefitsIcon}>
        <a href={HOW_VSG_WORKS_URL} target="_blank" rel="noreferrer" className="stark-button-bordered">
          Learn More
        </a>
      </NavigationTitle>
      <div className="trial-benefits-body">
        <Benefits />
      </div>
    </div>
  );
}

export default TrialBenefits;
